<template>
  <NodeEditorial v-if="node" v-slot="{ isEditing }" v-bind="node">
    <div v-if="isEditing" class="container">
      Placeholder for the Canto iframe.
    </div>
    <ClientOnly v-else>
      <CantoIframe />
    </ClientOnly>
  </NodeEditorial>
</template>

<script setup lang="ts">
definePageMeta({
  name: 'canto',
  path: '/business/medien/bild-und-videomaterial',
  drupalFrontendRoute: true,
  languageMapping: {
    en: '/business/media/image-and-video-material',
    es: '/business/medios/material-de-imagen-y-video',
  },
})

const { entity: node, metatags } = await useDrupalRouteQuery('editorial')

/* eslint-disable  @typescript-eslint/no-explicit-any */
useLogo().setLogoThemeFragment(node as any)
// The generic type V for the fragment can't be made compatible with these
// argument type, which is why we have to cast is as any here (which is fine).
/* eslint-disable  @typescript-eslint/no-explicit-any */
usePageTracking(node as any, metatags)
/* eslint-disable  @typescript-eslint/no-explicit-any */
setActiveChannel(node as any)

await renderPageDependencies()
</script>
